import React from "react"
import { imagePaths } from "./imagePaths";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Keyboard, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/keyboard';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar'
import { MoveRight } from "lucide-react";
import { publicRoutes } from "Routes/allRoutes";
import ElementRequestForm from "pages/ElementRequestForm";
import { WithTranslationProps } from "Common/Components/Translation/WithTranslationProps";
import withTranslation from "Common/withTranslation";

const Brands: React.FC<WithTranslationProps> = ({t}) => {
    return (
        <React.Fragment>
            <section className="relative py-16">
                <div className="container ">
                    <div className="mb-4 text-center items-center justify-center rounded-md">
                        <div className="row mb-4">
                            <div className="d-flex justify-content-center">
                                <h1 className="mb-6 leading-normal"><span className="relative inline-block px-2 mx-2 before:block before:absolute before:-inset-1 before:-skew-y-6 before:bg-sky-50 dark:before:bg-sky-500/20 before:rounded-md before:backdrop-blur-xl"><span className="relative text-custom-500">{ t('Brands.Catalog') }</span></span></h1>                    
                            </div>
                        </div>            
                    </div>
                    <div className="">
                        <div className="row mb-4">
                            <div className="text-center">
                                <h3 className="mb-0 leading-normal">{ t('Brands.Title1') }</h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="d-flex justify-content-center text-center">
                                <a href="/Categories" className="text-custom-500 text-16">{ t('Brands.eShopLink') } <MoveRight className="inline-block w-4 h-4 align-middle ltr:ml-1 rtl:mr-1 rtl:rotate-180" /></a>
                            </div>
                        </div>
                        <div className="row mb-14">
                            <Swiper                         
                                slidesPerView={1}
                                spaceBetween={50}
                                breakpoints={{                                    
                                    640: {
                                        slidesPerView: 3,                                    
                                    },
                                }}
                                autoplay= { {
                                        delay: 3000,
                                }}      
                                keyboard={{
                                    enabled: true,                                    
                                }}                          
                                navigation={true}
                                scrollbar={{
                                    enabled: true
                                }}
                                modules={[Navigation, Autoplay, Keyboard, Scrollbar]}
                                >
                                    {imagePaths.map((path, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="p-5">
                                                <img src={path} alt=""/>  
                                            </div>
                                        </SwiperSlide>
                                    ))}                                
                            </Swiper>
                        </div>
                        <div className="row">
                            <h3 className="text-16 text-center">{ t('Brands.RequestProduct') } <a className="text-custom-500 text-16" href={publicRoutes.find(key => key.component === ElementRequestForm)?.path}>{ t('Brands.ButtonHere') }</a></h3>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    )
};

export default withTranslation(Brands);